export default "__VITE_ASSET__C1Pf$YBy__"